import React, { useEffect, useState } from "react";
//import "../../../incidents/cases/addCaseList.scss";
import GridTable from "../../../../library/custom/gridTable/GridTable";
import { TableLoader } from "../../../../library/common/Loader";
import {
  ORG_ID,
  GRID_DEFAULT_PAGE_SIZE,
  ROW_PER_PAGE_SIZE,
  USER_ID,
  PAGE_SIZE,
} from "../../../../constant/constant";
import BackBtn from "../../../../library/custom/backBtn/backBtn";
import NORow from "../../../../library/custom/noRow/noRow";
import { LESSON } from "../../../../constant/routeContant";
import Button from "../../../../library/custom/button/Button";
import SettingTable from "../../../incidents/incidentList/SettingTable";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { Grid } from "@mui/material";
import TextEditor from "../../../../library/custom/textEditor/TextEditor";
import {
  getFormatedDate,
  parseDate,
  getUserBaseDivisionInfo,
} from "../../../../utils/helper";
import ReportRowManipulte from "../../../incidents/incidentList/ReportRowManipulte";
import downloadIcon from "../../../../assets/downloadIcon.svg";

export default function AssignedLessonUser({
  getLessonAssignUserListData,
  lessonUserAssignListData,
  isLoading,
  lessonname,
  lessonId,
  fieldid,
  onSubmit,
  postunAssignLesson,
  setisunAssignbtn,
  setisdisable,
  isdisable,
  location,
}) {
  let titlelesson;
  if (fieldid === "true") {
    titlelesson = "COMPLETED USERS";
  } else if (fieldid === "false") {
    titlelesson = "NOT COMPLETED USERS";
  } else {
    titlelesson = "ASSIGNED USERS";
  }
  const dataBack = {
    title: "Back to LMS Dashboard",
    route: LESSON,
    state: location?.state,
  };
  const [selectedUserId, setselectedUserId] = useState([]);
  const [customMessage, setCustomMessage] = useState(
    "This is a reminder that you have training that is incomplete.",
  );
  const [open, setOpen] = React.useState(false);
  const [editInsName, setInsName] = useState(false);
  const [pageSize, setPageSize] = useState(GRID_DEFAULT_PAGE_SIZE);
  const [newPage, setPage] = useState(0);
  // handle alert mail==============================================
  const handleclickAssign = (userId) => {
    setOpen(true);
    setInsName(true);
    const useridArr = [];
    useridArr.push(userId);
    setselectedUserId(useridArr);
  };
  const handleAlertMail = () => {
    const data = {
      userId: selectedUserId,
      lessonCourseId: lessonId,
      lessonCoursetype: 1,
      dynamicText: customMessage,
    };

    onSubmit(data);
    setOpen(false);
    setCustomMessage(
      "This is a reminder that you have training that is incomplete.",
    );
  };

  const handleClose = () => {
    setCustomMessage(
      "This is a reminder that you have training that is incomplete.",
    );
    setOpen(false);
    setselectedUserId([]);
  };

  const onchangeCustomMessage = (e) => {
    setCustomMessage(e);
  };
  // handle alert all mail==============================================
  const handleclickAssignAll = () => {
    setOpen(true);
    setInsName(true);
    setselectedUserId([]);
  };
  const handleAlertAll = () => {
    const { hasBaseDivisionAdminAccess, baseDivisionIds } =
      getUserBaseDivisionInfo();
    const totalUsers = lessonUserAssignListData?.noOfRecords ?? 0;
    const data = {
      alertAll: true,
      lessonCourseId: lessonId,
      lessonCoursetype: 1,
      dynamicText: customMessage,
      listFilters: {
        pageNumber: 1,
        pageSize: totalUsers > 0 ? totalUsers : pageSize,
        lessonId: lessonId,
        isCompleted: fieldid,
        fromDate: "",
        toDate: "",
        isSendMail: false,
        divisionId: hasBaseDivisionAdminAccess ? baseDivisionIds : 0,
      },
    };

    onSubmit(data);
    setOpen(false);
    setCustomMessage(
      "This is a reminder that you have training that is incomplete.",
    );
  };
  // function for get lesson versions detail data
  const getcompletedlessondetail = (val) => {
    const dataArr = val?.map((data) => {
      if (data?.prevLessonDates) {
        return getFormatedDate(data?.prevLessonDates);
      }
    });

    return dataArr;
  };
  // column for Lesson assigned and Not Completed pages
  const handleunAssignLessonOnClick = (data) => {
    // assignedToId ======
    setisdisable(true);
    setisunAssignbtn(true);
    const dataResult = {
      orgId: parseInt(ORG_ID()),
      lessonId: lessonId,
      userId: data?.row?.assignedToId,
      modifiedBy: parseInt(USER_ID()),
    };

    postunAssignLesson(dataResult);
  };

  const handlePageSizeChange = (newPazeSize) => {
    setPageSize(newPazeSize);
    setPage(0);
    getLessonAssignUserListData({
      pageNumber: 1,
      pageSize: newPazeSize,
      lessonId: lessonId,
      isCompleted: fieldid,
      fromDate: "",
      toDate: "",
      isSendMail: false,
    });
  };

  const columns = [
    {
      field: "assignedTo",
      headerName: "Assigned To",
      width: 120,
      flex: 1,
      minWidth: 100,
    },

    {
      field: "dateAssigned",
      headerName: "Date Assigned",
      flex: 1,
      minWidth: 100,
    },
    {
      field: "timeEstimatedMins",
      headerName: "Time Estimated",
      type: "text",
      flex: 1,
      minWidth: 100,
    },
    {
      field: "timeElapsedMins",
      headerName: "Time Elapsed",
      type: "text",
      flex: 1,
      minWidth: 100,
    },
    {
      field: "timeElapsedMins12",
      headerName: fieldid === "false" ? "Completed Times" : "Assigned Times",
      type: "text",
      flex: 1,
      minWidth: 100,
      renderCell: (cellValues) => {
        return <div>{1} times</div>;
      },
    },
    {
      field: "lessonCompleteOrAssignDate",
      headerName: "Assigned On",
      type: "text",
      flex: 1,
      minWidth: 100,
      renderCell: (rows) => {
        const dateString = rows?.row?.lessonCompleteOrAssignDate;
        const formattedDate =
          dateString && !isNaN(Date.parse(dateString))
            ? new Date(dateString)
            : parseDate(dateString, "MM-dd-yyyy");
        const options = { year: "numeric", month: "2-digit", day: "2-digit" };
        const lessonCompleteOrAssignDate =
          formattedDate instanceof Date && !isNaN(formattedDate)
            ? formattedDate.toLocaleDateString("en-US", options)
            : null;
        return <div>{lessonCompleteOrAssignDate}</div>;
      },
    },
    {
      field: "icon",
      renderHeader: () => (
        <SettingTable
          noOfRecords={lessonUserAssignListData?.noOfRecords ?? 0}
          numberOfItemsPerPage={PAGE_SIZE}
          incidentLists={
            lessonUserAssignListData?.assignedUserAdminResponse ?? []
          }
          fileNameXL={
            fieldid === "false" ? "LessonAssigned" : "LessonCompleted"
          }
        />
      ),
      width: fieldid === "false" ? 150 : 100,
      minWidth: fieldid === "false" ? 150 : 100,
      sortable: false,
      disableClickEventBubbling: true,

      renderCell: (cellValues) => {
        if (fieldid === "false") {
          return (
            <>
              {" "}
              <div className="alertSet">
                <div className="alertbtn">
                  <Button
                    primaryalert={true}
                    onClick={(row) => handleclickAssign(cellValues?.id)}
                    label="Alert"
                  />
                </div>
                <ReportRowManipulte
                  rows={cellValues}
                  unAssignLesson={true}
                  unAssignLessonLabel={
                    <span className={isdisable ? "disableclss" : ""}>
                      {" "}
                      Unassign Lesson
                    </span>
                  }
                  unAssignLessonOnclick={() =>
                    !isdisable && handleunAssignLessonOnClick(cellValues)
                  }
                />
              </div>
            </>
          );
        }
      },
    },
  ];
  if (fieldid === "false") {
    columns.splice(4, 2);
  }
  // column for Lesson Complete pages
  const columnsLessonComplete = [
    {
      field: "assignedTo",
      headerName: "Completed By",
      width: 120,
      flex: 1,
      minWidth: 120,
    },

    {
      field: "dateAssigned",
      headerName: "Date Assigned",
      flex: 1,
      minWidth: 120,
    },
    {
      field: "timeEstimatedMins",
      headerName: "Time Estimated",
      type: "text",
      flex: 1,
      minWidth: 120,
    },
    {
      field: "timeElapsedMins",
      headerName: "Time Elapsed",
      type: "text",
      flex: 1,
      minWidth: 120,
    },
    {
      field: "timeElapsedMins12",
      headerName: "Completed Times",
      type: "text",
      flex: 1,
      minWidth: 120,
      renderCell: (cellValues) => {
        return <div>{1} times</div>;
      },
    },
    {
      field: "lessonCompleteOrAssignDate",
      headerName: "Completed On",
      type: "text",
      flex: 1,
      minWidth: 100,
      renderCell: (rows) => {
        const dateString = rows?.row?.lessonCompleteOrAssignDate;
        const formattedDate =
          dateString && !isNaN(Date.parse(dateString))
            ? new Date(dateString)
            : parseDate(dateString, "MM-dd-yyyy");
        const options = { year: "numeric", month: "2-digit", day: "2-digit" };
        const lessonCompleteOrAssignDate =
          formattedDate instanceof Date && !isNaN(formattedDate)
            ? formattedDate.toLocaleDateString("en-US", options)
            : null;
        return <div>{lessonCompleteOrAssignDate}</div>;
      },
    },
    {
      field: "icon",
      renderHeader: () => (
        <SettingTable
          noOfRecords={lessonUserAssignListData?.noOfRecords ?? 0}
          numberOfItemsPerPage={PAGE_SIZE}
          incidentLists={
            lessonUserAssignListData?.assignedUserAdminResponse ?? []
          }
          fileNameXL={
            fieldid === "false" ? "LessonAssigned" : "LessonCompleted"
          }
        />
      ),
      width: 90,
      sortable: false,
      disableClickEventBubbling: true,

      renderCell: (cellValues) => {
        if (fieldid === "false") {
          return (
            <div className="alertbtn">
              <Button
                primaryalert={true}
                onClick={(row) => handleclickAssign(cellValues?.id)}
                label="Alert"
              />
            </div>
          );
        }
      },
    },
  ];
  const handlePagignation = (newPage) => {
    setPage(newPage);
    getLessonAssignUserListData({
      pageNumber: newPage + 1,
      pageSize: pageSize,
      lessonId: lessonId,
      isCompleted: fieldid,
      fromDate: "",
      toDate: "",
      isSendMail: false,
    });
  };

  const sendEmail = () => {
    const data = {
      pageNumber: 1,
      pageSize: GRID_DEFAULT_PAGE_SIZE,
      lessonId: lessonId,
      isCompleted: fieldid,
      fromDate: "",
      toDate: "",
      isSendMail: true,
    };
    getLessonAssignUserListData(data);
  };

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Grid className="modalContainer">
          {editInsName && (
            <Box className="modalBox">
              <div className="modalTitle">Send Custom Message</div>

              <Grid container mt={2} className="lesson-alert-model">
                <Grid item xs={12}>
                  <TextEditor
                    value={customMessage}
                    placeholderText={"Enter Here..."}
                    onChange={(e) => {
                      onchangeCustomMessage(e);
                    }}
                  />
                </Grid>
              </Grid>

              <Grid container className="modalFooterBox" mt={2}>
                <Grid item lg={2} xs={12} sm={3} md={3}>
                  <Button
                    varientText={true}
                    label="Cancel"
                    onClick={handleClose}
                  />
                </Grid>
                <Grid item lg={3} xs={12} sm={3} md={3}>
                  <Button
                    redButton={true}
                    label={"Send Alert"}
                    onClick={
                      selectedUserId.length > 0
                        ? handleAlertMail
                        : handleAlertAll
                    }
                  />
                </Grid>
              </Grid>
            </Box>
          )}
        </Grid>
      </Modal>

      <BackBtn dataBack={dataBack} />
      <div className="assignDivtitle">
        <div className="assigntitle">
          <div className="lessonnme">{lessonname}</div>

          <div className="lessonnmeT">{titlelesson}</div>
        </div>
        <div className="rightFilter lmsDownloadData">
          <div className="div-download-email-right" onClick={sendEmail}>
            <span>
              <img
                src={downloadIcon}
                className="DownLoadLogo"
                alt="DownLoad Logo"
              />
            </span>
            Download Data
          </div>
        </div>
        {fieldid == "false" && (
          <div className="allertall">
            {lessonUserAssignListData?.assignedUserAdminResponse.length > 1 && (
              <Button
                primaryalertAll={true}
                onClick={(row) => handleclickAssignAll()}
                label="Alert All"
              />
            )}
          </div>
        )}
      </div>

      <div className="table_style_ui">
        <GridTable
          getRowId={(r) => `${r.assignedToId}_${r.lessonCompleteOrAssignDate}`}
          rows={
            lessonUserAssignListData?.assignedUserAdminResponse
              ? lessonUserAssignListData?.assignedUserAdminResponse
              : []
          }
          columns={
            fieldid === "false" || fieldid === ""
              ? columns
              : columnsLessonComplete
          }
          page={newPage}
          pageSize={pageSize}
          rowsPerPageOptions={ROW_PER_PAGE_SIZE}
          onPageSizeChange={handlePageSizeChange}
          rowCount={lessonUserAssignListData?.noOfRecords ?? 0}
          paginationMode="server"
          loading={isLoading}
          onPageChange={handlePagignation}
          disableColumnSelector
          disableColumnFilter
          disableColumnMenu
          CanUserAddRows="False"
          IsReadOnly="True"
          components={{
            LoadingOverlay: TableLoader,
            NoRowsOverlay: NORow,
          }}
        />
      </div>
    </>
  );
}
